import { render, staticRenderFns } from "./BrakePads.vue?vue&type=template&id=7da4280c&scoped=true"
import script from "./BrakePads.vue?vue&type=script&lang=js"
export * from "./BrakePads.vue?vue&type=script&lang=js"
import style0 from "./BrakePads.vue?vue&type=style&index=0&id=7da4280c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da4280c",
  null
  
)

export default component.exports